import React from 'react'
import { HelmetTags } from '../../components/HelmetTags'
import { Pay as PayController } from '../../components/Pay'

export const Pay = (props) => {
  return (
    <>
      <HelmetTags page='pay' />
      <PayController {...props} />
    </>
  )
}
